/** @format */
import React, { useEffect, useState } from "react";
import Sidebar from "../../components/layout/common/Sidebar";
import Header from "../../components/layout/common/Header";
import { Outlet } from "react-router-dom";
import { SessionProvider } from "../SessionProvider";

const Main = ({ children, handleStudentHome, handleStudentSessionIdHome }) => {
  console.log("childrend=>", children);
  console.log("handleStudentHome22@@=>", handleStudentHome);
  console.log("handleStudentSessionIdHome@@=>", handleStudentSessionIdHome);
  // const [selectedStudent, setSelectedStudent] = useState([]);
  const [optionStudents, setOptionStudents] = useState([]);
  const [optionSession, setOptionSession] = useState([]);
  const [selectedStudent, setStudent] = useState(null);

  const studentList = (result) => {
    console.log("result on Main111", result);
    if (result) {
      console.log("jhjkdhkhkh");
      setOptionStudents(result);
    }
  };

  const sessionList = (result) => {
    if (result) {
      setOptionSession(result);
    }
  };

  return (
    <div className="wrapper">
      <Sidebar className="sidebar-style" />
      <SessionProvider>
        <div id="content">
          <Header
            studentList={studentList}
            sessionList={sessionList}
            selectedStudent={selectedStudent}
            setStudent={setStudent}
          />
          <Outlet context={[selectedStudent, setStudent, studentList]} />
        </div>
      </SessionProvider>
    </div>
  );
};

export default Main;
